import { IFeatures } from "./../types";

export const featuresInitialData: IFeatures = {
  isRidesEnabled: false,
  isAutomaticReportsEnabled: false //
};
